














































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import MessageMixin from './Message';
import { URL_REGEX } from '@common/app.config';
import sanitizeHtml from 'sanitize-html';

@Component
export default class MessageTemplate extends Mixins(MessageMixin) {
  @Prop() avatarUser!: any;
  @Prop() avatarManager!: any;
  @Prop() readonly isHovered!: boolean;
  @Prop() readonly isFirstMsg!: boolean;
  @Prop({type: Number, default: null}) readonly lastPatientReadMessageId!: number | null;

  isMenuOpen: boolean = false;

  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  }

  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  convertToUrl(content) {
    const pattern = new RegExp(URL_REGEX);
    return sanitizeHtml(
      content.replace(pattern, '<a href="$1" target="_blank">$1</a>'),
    );
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  handleHideMenuAction() {
    this.$emit('hover', null);
    this.isMenuOpen = false;
  }

  handleClickOutside(e: MouseEvent) {
    const menu = this.$refs.actionMenu as HTMLElement;
    if (menu && !menu.contains(e.target as Node)) {
      this.isMenuOpen = false;
    }
  }
}
